import { useSuspenseQuery } from '@rocicorp/zero/react'

import { authMeFromZero } from '#zero/auth-me-from-zero.ts'
import { queries } from '#zero/queries.ts'

export const useCurrentUser = () => {
  const [row] = useSuspenseQuery(queries.auth.me(), {
    suspendUntil: 'complete',
  })
  if (row === undefined) {
    throw new Error('Zero auth.me returned no row (user missing in replica)')
  }
  return [authMeFromZero(row)] as const
}
